"use client";

import { useState } from "react";
import ICON_ARROW_UP from "@/assets/images/arrow-up.svg";

export default function StakeMatchLeagues({ league, matches = [], render = () => null }) {
  const [isExpanded, setIsExpanded] = useState(true);
  const { name, logo } = league || {};

  return (
    <div className="w-full overflow-hidden rounded-xl border border-[var(--theme-border)] stake-bg-header">
      <button
        type="button"
        onClick={() => setIsExpanded((prev) => !prev)}
        className="flex w-full items-center justify-between gap-2  px-3 py-2 text-left"
      >
        <div className="flex min-w-0 items-center gap-2">
          {logo ? (
            <img
              src={logo}
              alt={name || "league"}
              className="h-4 w-4 shrink-0 object-contain"
              width={16}
              height={16}
              loading="lazy"
            />
          ) : null}
          <span className="truncate text-base font-semibold text-[var(--theme-text)]">
            {name}
          </span>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          {!isExpanded ? (
            <span className="inline-flex min-w-[32px] items-center justify-center rounded-full bg-[#395565] px-2 py-0.5 text-sm font-semibold text-white">
              {matches.length}
            </span>
          ) : null}
          <img
            src={ICON_ARROW_UP}
            alt=""
            width={20}
            height={20}
            className={`h-5 w-5 shrink-0 transition-transform brightness-0 invert ${isExpanded ? "rotate-180" : "rotate-0"}`}
          />
        </div>
      </button>

      {isExpanded ? (
        <div className="bg-[var(--theme-bg)] p-0">
          {matches.map((match) => render(match))}
        </div>
      ) : null}
    </div>
  );
}
